import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <AppSection />
        <UpdatesSection />
        <ContactSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}